import Vue from 'vue'
import Router from 'vue-router'
import pathPrefix from './pathPrefix.js'  

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: `${pathPrefix}`,
      redirect: `${pathPrefix}/home`
    },
    {
      path: `${pathPrefix}/home`,
      name: 'Home',
      component: () => import('./pages/Home.vue')
    },
    {
      path: `${pathPrefix}/about`,
      name: 'About',
      component: () => import('./pages/About.vue')
    },
    {
      path: `${pathPrefix}/trainings`,
      name: 'Trainings',
      component: () => import('./pages/Trainings.vue')
    },
    ,
    {
      path: `${pathPrefix}/trainings/:id`,
      name: 'FakeTrainings',
      component: () => import('./pages/Trainings.vue')
    },
    {
      path: `${pathPrefix}/contact`,
      name: 'Contact',
      component: () => import('./pages/Contact.vue')
    },
    {
      path: `${pathPrefix}/register`,
      name: 'registration',
      component: () => import('./pages/Registration.vue')
    },
  ],
  scrollBehavior(to) {
    if (to.name == "FakeTrainings") {
      document.getElementsByClassName('selected_elem')[0].scrollIntoView({behavior: "smooth", block: "center"});
      document.getElementsByClassName('selected_elem')[1].scrollIntoView({behavior: "smooth", block: "center"});
    }
  }
})

